import { Button } from '@/components'

interface SubmitPlanProps {
  loadingText?: string
  agreedToTerms?: boolean
  isMutating?: boolean
  children: React.ReactNode
}

export const SubmitPlan = ({
  children,
  agreedToTerms,
  isMutating,
  loadingText = 'Creating account...',
}: SubmitPlanProps) => (
  <Button
    type="submit"
    className="w-full mt-4 sm:mt-5 md:mt-6"
    disabled={!agreedToTerms}
    isLoading={isMutating}
    loadingText={loadingText}
    size="lg"
  >
    {children}
  </Button>
)
